import React from 'react';

export const Col: React.FC<{ children?: React.ReactNode; span?: number }> = ({ children, span = 16, ...props }) => {
	return <div className={`col-xs-${span}`}>{children}</div>;
};
